import { rootUrl } from '@/constants';
import axios from 'axios';

export type SubmitGetTestsQuestions = {
  type: string;
  lang: string;
};

export interface ResponseLevel {
  t: string; // Описание уровня раздражения
  s: number; // Балл
}

export interface Step {
  g: string; // Описание ситуации
  v: ResponseLevel[]; // Возможные уровни раздражения
}

interface StepDescription {
  text: string;
  fact?: string;
}

interface Result {
  text: string;
  title: string;
  rangeBefore: number; // Максимальное значение диапазона
}

interface Recommends {
  activities: string[]; // Идентификаторы рекомендованных активностей
}

interface Description {
  text: string[]; // Описание теста
  sourceLink: string; // Ссылка на источник
}

interface QuestionTest {
  title: string;
  steps: Step[];
  steps_description: StepDescription[]; // Описания шагов
  result: Result[];
  recommends: Recommends; // Рекомендации
  description: Description; // Описание теста
}

export type ResponseGetTestsQuestions = QuestionTest;

export const getTestsQuestions = async (data: SubmitGetTestsQuestions) => {
  const normalizedType = data.type.toLowerCase();
  const response = await axios.post(
    `${rootUrl}/psy-tests/test`,
    {
      testType: normalizedType,
      lang: data.lang,
    },
    {
      params: {
        testType: normalizedType,
        lang: data.lang,
      },
      headers: {
        lang: data.lang,
      },
    }
  );

  return response.data;
};
